<span
  class="shopping-cart-wrapper {{className}}"
  (click)="onSelectTourShop($event, tour)"
  [class.active]="tour.shopState">
    <i class="fas fa-shopping-cart shopping-cart"></i>
</span>

